import {
  handleWithErrorMessage,
  handleWithGlobalMessage
} from "@/services/utils";
import api from "@/services/modules/users/experience";
import {
  SET_IS_FETCHING_USER_EXPERIENCE,
  SET_CURRENT_USER_EXPERIENCE,
  SET_IS_FETCHING_EXPERIENCE_FUNCTIONS,
  SET_IS_FETCHING_REASONS_FOR_LEAVING,
  SET_EXPERIENCE_FUNCTIONS,
  SET_REASONS_FOR_LEAVING
} from "@/store/modules/users/experience/mutations";
import { filter, map } from "lodash";

export const FETCH_USER_EXPERIENCE = "FETCH_USER_EXPERIENCE";
export const REMOVE_USER_EXPERIENCE = "REMOVE_USER_EXPERIENCE";
export const ADD_USER_EXPERIENCE = "ADD_USER_EXPERIENCE";
export const EDIT_USER_EXPERIENCE = "EDIT_USER_EXPERIENCE";
export const FETCH_EXPERIENCE_FUNCTIONS = "FETCH_EXPERIENCE_FUNCTIONS";
export const FETCH_REASONS_FOR_LEAVING = "FETCH_REASONS_FOR_LEAVING";
export const FETCH_USER_BOOKING_EXPERIENCE = "FETCH_USER_BOOKING_EXPERIENCE";

const actions = {
  async [FETCH_USER_EXPERIENCE]({ commit, dispatch }, userId) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getUserExperience(userId),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_USER_EXPERIENCE, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_USER_EXPERIENCE, data)
    });
  },
  async [FETCH_USER_BOOKING_EXPERIENCE](
    { commit, dispatch },
    { userId, bookingId }
  ) {
    return handleWithErrorMessage({
      dispatch,
      request: () =>
        api(commit).getUserBookingExperience({ userId, bookingId }),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_USER_EXPERIENCE, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_USER_EXPERIENCE, data)
    });
  },
  async [FETCH_EXPERIENCE_FUNCTIONS]({ commit, dispatch }, params) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getExperienceFunctions(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_EXPERIENCE_FUNCTIONS, isLoading),
      setDataFunction: ({ data }) => commit(SET_EXPERIENCE_FUNCTIONS, data)
    });
  },
  async [FETCH_REASONS_FOR_LEAVING]({ commit, dispatch }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getReasonsForLeaving,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_REASONS_FOR_LEAVING, isLoading),
      setDataFunction: ({ data }) => commit(SET_REASONS_FOR_LEAVING, data)
    });
  },
  async [ADD_USER_EXPERIENCE]({ commit, dispatch, state }, experience) {
    const { data: newExperience } = await handleWithGlobalMessage(
      () => api(commit).addUserExperience(experience),
      dispatch
    );
    const currentExperiences = state.currentUserExperience;
    const newExperiences = [...currentExperiences, newExperience];
    commit(SET_CURRENT_USER_EXPERIENCE, newExperiences);
  },
  async [EDIT_USER_EXPERIENCE]({ commit, dispatch, state }, experience) {
    const { data: updatedExperience } = await handleWithGlobalMessage(
      () => api(commit).editUserExperience(experience),
      dispatch
    );
    const updatedExperiences = map(state.currentUserExperience, experience => {
      if (experience.id !== updatedExperience.id) return experience;
      return updatedExperience;
    });
    commit(SET_CURRENT_USER_EXPERIENCE, updatedExperiences);
  },
  async [REMOVE_USER_EXPERIENCE]({ commit, dispatch, state }, experienceId) {
    await handleWithGlobalMessage(
      () => api(commit).removeUserExperience(experienceId),
      dispatch
    );
    const currentExperiences = state.currentUserExperience;
    const newExperiences = filter(
      currentExperiences,
      ({ id }) => id !== experienceId
    );
    commit(SET_CURRENT_USER_EXPERIENCE, newExperiences);
  }
};

export default actions;
